import DesktopAccessDisabledIcon from '@mui/icons-material/DesktopAccessDisabled'

import { EmptyState } from 'components/empty-state/EmptyState'

export type NotFoundViewProps = {
  fullHeight?: 'container' | 'viewport'
  onBackToHome: () => void
}

export const NotFoundView: React.FC<NotFoundViewProps> = ({
  fullHeight = 'viewport',
  onBackToHome,
}) => (
  <EmptyState
    fullHeight={fullHeight}
    icon={<DesktopAccessDisabledIcon style={{ fontSize: 48 }} />}
    title="This page does not exist"
    description="Sorry, the page you visited does not exist or is not available."
    textWidth="300px"
    actions={[
      {
        label: 'Back to Home',
        onClick: onBackToHome,
      },
    ]}
  />
)
